package pl.finn.forms.tw17

object Tw17Data {

  val listOfTaxOffices = listOf(
    "0202 URZĄD SKARBOWY W BOLESŁAWCU ",
    "0203 URZĄD SKARBOWY W BYSTRZYCY KŁODZKIEJ ",
    "0204 URZĄD SKARBOWY W DZIERŻONIOWIE ",
    "0205 URZĄD SKARBOWY W GŁOGOWIE ",
    "0206 URZĄD SKARBOWY W JAWORZE ",
    "0207 URZĄD SKARBOWY W JELENIEJ GÓRZE ",
    "0208 URZĄD SKARBOWY W KAMIENNEJ GÓRZE ",
    "0209 URZĄD SKARBOWY W KŁODZKU ",
    "0210 URZĄD SKARBOWY W LEGNICY ",
    "0211 URZĄD SKARBOWY W LUBANIU ",
    "0212 URZĄD SKARBOWY W LUBINIE ",
    "0213 URZĄD SKARBOWY W LWÓWKU ŚLĄSKIM ",
    "0214 URZĄD SKARBOWY W MILICZU ",
    "0215 URZĄD SKARBOWY W NOWEJ RUDZIE ",
    "0216 URZĄD SKARBOWY W OLEŚNICY ",
    "0217 URZĄD SKARBOWY W OŁAWIE ",
    "0218 URZĄD SKARBOWY W STRZELINIE ",
    "0219 URZĄD SKARBOWY W ŚRODZIE ŚLĄSKIEJ ",
    "0220 URZĄD SKARBOWY W ŚWIDNICY ",
    "0221 URZĄD SKARBOWY W TRZEBNICY ",
    "0222 URZĄD SKARBOWY W WAŁBRZYCHU ",
    "0223 URZĄD SKARBOWY W WOŁOWIE ",
    "0224 URZĄD SKARBOWY WROCŁAW-FABRYCZNA ",
    "0225 URZĄD SKARBOWY WROCŁAW-KRZYKI ",
    "0226 URZĄD SKARBOWY WROCŁAW-PSIE POLE ",
    "0227 URZĄD SKARBOWY WROCŁAW-STARE MIASTO ",
    "0228 URZĄD SKARBOWY WROCŁAW-ŚRÓDMIEŚCIE ",
    "0229 PIERWSZY URZĄD SKARBOWY WE WROCŁAWIU ",
    "0230 URZĄD SKARBOWY W ZĄBKOWICACH ŚLĄSKICH ",
    "0231 URZĄD SKARBOWY W ZGORZELCU ",
    "0232 URZĄD SKARBOWY W ZŁOTORYI ",
    "0233 URZĄD SKARBOWY W GÓRZE ",
    "0234 URZĄD SKARBOWY W POLKOWICACH ",
    "0271 DOLNOŚLĄSKI URZĄD SKARBOWY WE WROCŁAWIU ",
    "0402 URZĄD SKARBOWY W ALEKSANDROWIE KUJAWSKIM ",
    "0403 URZĄD SKARBOWY W BRODNICY ",
    "0404 PIERWSZY URZĄD SKARBOWY W BYDGOSZCZY ",
    "0405 DRUGI URZĄD SKARBOWY W BYDGOSZCZY ",
    "0406 TRZECI URZĄD SKARBOWY W BYDGOSZCZY ",
    "0407 URZĄD SKARBOWY W CHEŁMNIE ",
    "0408 URZĄD SKARBOWY W GRUDZIĄDZU ",
    "0409 URZĄD SKARBOWY W INOWROCŁAWIU ",
    "0410 URZĄD SKARBOWY W LIPNIE ",
    "0411 URZĄD SKARBOWY W MOGILNIE ",
    "0412 URZĄD SKARBOWY W NAKLE NAD NOTECIĄ ",
    "0413 URZĄD SKARBOWY W RADZIEJOWIE ",
    "0414 URZĄD SKARBOWY W RYPINIE ",
    "0415 URZĄD SKARBOWY W ŚWIECIU ",
    "0416 PIERWSZY URZĄD SKARBOWY W TORUNIU ",
    "0417 DRUGI URZĄD SKARBOWY W TORUNIU ",
    "0418 URZĄD SKARBOWY W TUCHOLI ",
    "0419 URZĄD SKARBOWY W WĄBRZEŹNIE ",
    "0420 URZĄD SKARBOWY WE WŁOCŁAWKU ",
    "0421 URZĄD SKARBOWY W ŻNINIE ",
    "0422 URZĄD SKARBOWY W GOLUBIU-DOBRZYNIU ",
    "0423 URZĄD SKARBOWY W SĘPÓLNIE KRAJEŃSKIM ",
    "0471 KUJAWSKO-POMORSKI URZĄD SKARBOWY W BYDGOSZCZY ",
    "0602 URZĄD SKARBOWY W BIAŁEJ PODLASKIEJ ",
    "0603 URZĄD SKARBOWY W BIŁGORAJU ",
    "0604 URZĄD SKARBOWY W CHEŁMIE ",
    "0605 URZĄD SKARBOWY W HRUBIESZOWIE ",
    "0606 URZĄD SKARBOWY W JANOWIE LUBELSKIM ",
    "0607 URZĄD SKARBOWY W KRASNYMSTAWIE ",
    "0608 URZĄD SKARBOWY W KRAŚNIKU ",
    "0609 URZĄD SKARBOWY W LUBARTOWIE ",
    "0610 PIERWSZY URZĄD SKARBOWY W LUBLINIE ",
    "0611 DRUGI URZĄD SKARBOWY W LUBLINIE ",
    "0612 TRZECI URZĄD SKARBOWY W LUBLINIE ",
    "0613 URZĄD SKARBOWY W ŁUKOWIE ",
    "0614 URZĄD SKARBOWY W OPOLU LUBELSKIM ",
    "0615 URZĄD SKARBOWY W PARCZEWIE ",
    "0616 URZĄD SKARBOWY W PUŁAWACH ",
    "0617 URZĄD SKARBOWY W RADZYNIU PODLASKIM ",
    "0618 URZĄD SKARBOWY W TOMASZOWIE LUBELSKIM ",
    "0619 URZĄD SKARBOWY WE WŁODAWIE ",
    "0620 URZĄD SKARBOWY W ZAMOŚCIU ",
    "0621 URZĄD SKARBOWY W ŁĘCZNEJ ",
    "0622 URZĄD SKARBOWY W RYKACH ",
    "0671 LUBELSKI URZĄD SKARBOWY W LUBLINIE ",
    "0802 URZĄD SKARBOWY W GORZOWIE WIELKOPOLSKIM ",
    "0803 URZĄD SKARBOWY W KROŚNIE ODRZAŃSKIM ",
    "0804 URZĄD SKARBOWY W MIĘDZYRZECZU ",
    "0805 URZĄD SKARBOWY W NOWEJ SOLI ",
    "0806 URZĄD SKARBOWY W SŁUBICACH ",
    "0807 URZĄD SKARBOWY W ŚWIEBODZINIE ",
    "0808 PIERWSZY URZĄD SKARBOWY W ZIELONEJ GÓRZE ",
    "0809 DRUGI URZĄD SKARBOWY W ZIELONEJ GÓRZE ",
    "0810 URZĄD SKARBOWY W ŻAGANIU ",
    "0811 URZĄD SKARBOWY W ŻARACH ",
    "0812 URZĄD SKARBOWY W DREZDENKU ",
    "0813 URZĄD SKARBOWY W SULĘCINIE ",
    "0814 URZĄD SKARBOWY WE WSCHOWIE ",
    "0871 LUBUSKI URZĄD SKARBOWY W ZIELONEJ GÓRZE ",
    "1002 URZĄD SKARBOWY W BEŁCHATOWIE ",
    "1003 URZĄD SKARBOWY W BRZEZINACH ",
    "1004 URZĄD SKARBOWY W GŁOWNIE ",
    "1005 URZĄD SKARBOWY W KUTNIE ",
    "1006 URZĄD SKARBOWY W ŁASKU ",
    "1007 URZĄD SKARBOWY W ŁOWICZU ",
    "1008 PIERWSZY URZĄD SKARBOWY ŁÓDŹ-BAŁUTY ",
    "1009 DRUGI URZĄD SKARBOWY ŁÓDŹ-BAŁUTY ",
    "1010 PIERWSZY URZĄD SKARBOWY ŁÓDŹ-GÓRNA ",
    "1011 DRUGI URZĄD SKARBOWY ŁÓDŹ-GÓRNA ",
    "1012 URZĄD SKARBOWY ŁÓDŹ-POLESIE ",
    "1013 URZĄD SKARBOWY ŁÓDŹ-ŚRÓDMIEŚCIE ",
    "1014 URZĄD SKARBOWY ŁÓDŹ-WIDZEW ",
    "1015 URZĄD SKARBOWY W OPOCZNIE ",
    "1016 URZĄD SKARBOWY W PABIANICACH ",
    "1017 URZĄD SKARBOWY W PIOTRKOWIE TRYBUNALSKIM ",
    "1018 URZĄD SKARBOWY W PODDĘBICACH ",
    "1019 URZĄD SKARBOWY W RADOMSKU ",
    "1020 URZĄD SKARBOWY W RAWIE MAZOWIECKIEJ ",
    "1021 URZĄD SKARBOWY W SIERADZU ",
    "1022 URZĄD SKARBOWY W SKIERNIEWICACH ",
    "1023 URZĄD SKARBOWY W TOMASZOWIE MAZOWIECKIM ",
    "1024 URZĄD SKARBOWY W WIELUNIU ",
    "1025 URZĄD SKARBOWY W ZDUŃSKIEJ WOLI ",
    "1026 URZĄD SKARBOWY W ZGIERZU ",
    "1027 URZĄD SKARBOWY W WIERUSZOWIE ",
    "1028 URZĄD SKARBOWY W ŁĘCZYCY ",
    "1029 URZĄD SKARBOWY W PAJĘCZNIE ",
    "1071 ŁÓDZKI URZĄD SKARBOWY W ŁODZI ",
    "1202 URZĄD SKARBOWY W BOCHNI ",
    "1203 URZĄD SKARBOWY W BRZESKU ",
    "1204 URZĄD SKARBOWY W CHRZANOWIE ",
    "1205 URZĄD SKARBOWY W DĄBROWIE TARNOWSKIEJ ",
    "1206 URZĄD SKARBOWY W GORLICACH ",
    "1207 PIERWSZY URZĄD SKARBOWY KRAKÓW ",
    "1208 URZĄD SKARBOWY KRAKÓW-KROWODRZA ",
    "1209 URZĄD SKARBOWY KRAKÓW-NOWA HUTA ",
    "1210 URZĄD SKARBOWY KRAKÓW-PODGÓRZE ",
    "1211 URZĄD SKARBOWY KRAKÓW-PRĄDNIK ",
    "1212 URZĄD SKARBOWY KRAKÓW-STARE MIASTO ",
    "1213 URZĄD SKARBOWY KRAKÓW-ŚRÓDMIEŚCIE ",
    "1214 URZĄD SKARBOWY W LIMANOWEJ ",
    "1215 URZĄD SKARBOWY W MIECHOWIE ",
    "1216 URZĄD SKARBOWY W MYŚLENICACH ",
    "1217 URZĄD SKARBOWY W NOWYM SĄCZU ",
    "1218 URZĄD SKARBOWY W NOWYM TARGU ",
    "1219 URZĄD SKARBOWY W OLKUSZU ",
    "1220 URZĄD SKARBOWY W OŚWIĘCIMIU ",
    "1221 URZĄD SKARBOWY W PROSZOWICACH ",
    "1222 URZĄD SKARBOWY W SUCHEJ BESKIDZKIEJ ",
    "1223 PIERWSZY URZĄD SKARBOWY W TARNOWIE ",
    "1224 DRUGI URZĄD SKARBOWY W TARNOWIE ",
    "1225 URZĄD SKARBOWY W WADOWICACH ",
    "1226 URZĄD SKARBOWY W WIELICZCE ",
    "1227 URZĄD SKARBOWY W ZAKOPANEM ",
    "1228 DRUGI URZĄD SKARBOWY KRAKÓW ",
    "1271 MAŁOPOLSKI URZĄD SKARBOWY W KRAKOWIE ",
    "1402 URZĄD SKARBOWY W BIAŁOBRZEGACH ",
    "1403 URZĄD SKARBOWY W CIECHANOWIE ",
    "1404 URZĄD SKARBOWY W GARWOLINIE ",
    "1405 URZĄD SKARBOWY W GOSTYNINIE ",
    "1406 URZĄD SKARBOWY W GRODZISKU MAZOWIECKIM ",
    "1407 URZĄD SKARBOWY W GRÓJCU ",
    "1408 URZĄD SKARBOWY W KOZIENICACH ",
    "1409 URZĄD SKARBOWY W LEGIONOWIE ",
    "1410 URZĄD SKARBOWY W ŁOSICACH ",
    "1411 URZĄD SKARBOWY W MAKOWIE MAZOWIECKIM ",
    "1412 URZĄD SKARBOWY W MIŃSKU MAZOWIECKIM ",
    "1413 URZĄD SKARBOWY W MŁAWIE ",
    "1414 URZĄD SKARBOWY W NOWYM DWORZE MAZOWIECKIM ",
    "1415 URZĄD SKARBOWY W OSTROŁĘCE ",
    "1416 URZĄD SKARBOWY W OSTROWI MAZOWIECKIEJ ",
    "1417 URZĄD SKARBOWY W OTWOCKU ",
    "1418 URZĄD SKARBOWY W PIASECZNIE ",
    "1419 URZĄD SKARBOWY W PŁOCKU ",
    "1420 URZĄD SKARBOWY W PŁOŃSKU ",
    "1421 URZĄD SKARBOWY W PRUSZKOWIE ",
    "1422 URZĄD SKARBOWY W PRZASNYSZU ",
    "1423 URZĄD SKARBOWY W PUŁTUSKU ",
    "1424 PIERWSZY URZĄD SKARBOWY W RADOMIU ",
    "1425 DRUGI URZĄD SKARBOWY W RADOMIU ",
    "1426 URZĄD SKARBOWY W SIEDLCACH ",
    "1427 URZĄD SKARBOWY W SIERPCU ",
    "1428 URZĄD SKARBOWY W SOCHACZEWIE ",
    "1429 URZĄD SKARBOWY W SOKOŁOWIE PODLASKIM ",
    "1430 URZĄD SKARBOWY W SZYDŁOWCU ",
    "1431 URZĄD SKARBOWY WARSZAWA-BEMOWO ",
    "1432 URZĄD SKARBOWY WARSZAWA-BIELANY ",
    "1433 URZĄD SKARBOWY WARSZAWA-MOKOTÓW ",
    "1434 URZĄD SKARBOWY WARSZAWA-PRAGA ",
    "1435 PIERWSZY URZĄD SKARBOWY WARSZAWA-ŚRÓDMIEŚCIE ",
    "1436 DRUGI URZĄD SKARBOWY WARSZAWA-ŚRÓDMIEŚCIE ",
    "1437 URZĄD SKARBOWY WARSZAWA-TARGÓWEK ",
    "1438 URZĄD SKARBOWY WARSZAWA-URSYNÓW ",
    "1439 URZĄD SKARBOWY WARSZAWA-WAWER ",
    "1440 URZĄD SKARBOWY WARSZAWA-WOLA ",
    "1441 URZĄD SKARBOWY W WĘGROWIE ",
    "1442 URZĄD SKARBOWY W WOŁOMINIE ",
    "1443 URZĄD SKARBOWY W WYSZKOWIE ",
    "1444 URZĄD SKARBOWY W ZWOLENIU ",
    "1445 URZĄD SKARBOWY W ŻUROMINIE ",
    "1446 URZĄD SKARBOWY W ŻYRARDOWIE ",
    "1447 URZĄD SKARBOWY W LIPSKU ",
    "1448 URZĄD SKARBOWY W PRZYSUSZE ",
    "1449 TRZECI URZĄD SKARBOWY WARSZAWA-ŚRÓDMIEŚCIE ",
    "1471 PIERWSZY MAZOWIECKI URZĄD SKARBOWY W WARSZAWIE ",
    "1472 DRUGI MAZOWIECKI URZĄD SKARBOWY W WARSZAWIE ",
    "1473 TRZECI MAZOWIECKI URZĄD SKARBOWY W RADOMIU ",
    "1602 URZĄD SKARBOWY W BRZEGU ",
    "1603 URZĄD SKARBOWY W GŁUBCZYCACH ",
    "1604 URZĄD SKARBOWY W KĘDZIERZYNIE-KOŹLU ",
    "1605 URZĄD SKARBOWY W KLUCZBORKU ",
    "1606 URZĄD SKARBOWY W NAMYSŁOWIE ",
    "1607 URZĄD SKARBOWY W NYSIE ",
    "1608 URZĄD SKARBOWY W OLEŚNIE ",
    "1609 PIERWSZY URZĄD SKARBOWY W OPOLU ",
    "1610 DRUGI URZĄD SKARBOWY W OPOLU ",
    "1611 URZĄD SKARBOWY W PRUDNIKU ",
    "1612 URZĄD SKARBOWY W STRZELCACH OPOLSKICH ",
    "1613 URZĄD SKARBOWY W KRAPKOWICACH ",
    "1671 OPOLSKI URZĄD SKARBOWY W OPOLU ",
    "1802 URZĄD SKARBOWY W BRZOZOWIE ",
    "1803 URZĄD SKARBOWY W DĘBICY ",
    "1804 URZĄD SKARBOWY W JAROSŁAWIU ",
    "1805 URZĄD SKARBOWY W JAŚLE ",
    "1806 URZĄD SKARBOWY W KOLBUSZOWEJ ",
    "1807 URZĄD SKARBOWY W KROŚNIE ",
    "1808 URZĄD SKARBOWY W LESKU ",
    "1809 URZĄD SKARBOWY W LEŻAJSKU ",
    "1810 URZĄD SKARBOWY W LUBACZOWIE ",
    "1811 URZĄD SKARBOWY W ŁAŃCUCIE ",
    "1812 URZĄD SKARBOWY W MIELCU ",
    "1813 URZĄD SKARBOWY W PRZEMYŚLU ",
    "1814 URZĄD SKARBOWY W PRZEWORSKU ",
    "1815 URZĄD SKARBOWY W ROPCZYCACH ",
    "1816 PIERWSZY URZĄD SKARBOWY W RZESZOWIE ",
    "1817 URZĄD SKARBOWY W SANOKU ",
    "1818 URZĄD SKARBOWY W STALOWEJ WOLI ",
    "1819 URZĄD SKARBOWY W STRZYŻOWIE ",
    "1820 URZĄD SKARBOWY W TARNOBRZEGU ",
    "1821 URZĄD SKARBOWY W USTRZYKACH DOLNYCH ",
    "1822 DRUGI URZĄD SKARBOWY W RZESZOWIE ",
    "1823 URZĄD SKARBOWY W NISKU ",
    "1871 PODKARPACKI URZĄD SKARBOWY W RZESZOWIE ",
    "2002 URZĄD SKARBOWY W AUGUSTOWIE ",
    "2003 PIERWSZY URZĄD SKARBOWY W BIAŁYMSTOKU ",
    "2004 DRUGI URZĄD SKARBOWY W BIAŁYMSTOKU ",
    "2005 URZĄD SKARBOWY W BIELSKU PODLASKIM ",
    "2006 URZĄD SKARBOWY W GRAJEWIE ",
    "2007 URZĄD SKARBOWY W KOLNIE ",
    "2008 URZĄD SKARBOWY W ŁOMŻY ",
    "2009 URZĄD SKARBOWY W MOŃKACH ",
    "2010 URZĄD SKARBOWY W SIEMIATYCZACH ",
    "2011 URZĄD SKARBOWY W SOKÓŁCE ",
    "2012 URZĄD SKARBOWY W SUWAŁKACH ",
    "2013 URZĄD SKARBOWY W WYSOKIEM MAZOWIECKIEM ",
    "2014 URZĄD SKARBOWY W ZAMBROWIE ",
    "2015 URZĄD SKARBOWY W HAJNÓWCE ",
    "2071 PODLASKI URZĄD SKARBOWY W BIAŁYMSTOKU ",
    "2202 URZĄD SKARBOWY W BYTOWIE ",
    "2203 URZĄD SKARBOWY W CHOJNICACH ",
    "2204 URZĄD SKARBOWY W CZŁUCHOWIE ",
    "2205 PIERWSZY URZĄD SKARBOWY W GDAŃSKU ",
    "2206 DRUGI URZĄD SKARBOWY W GDAŃSKU ",
    "2207 TRZECI URZĄD SKARBOWY W GDAŃSKU ",
    "2208 PIERWSZY URZĄD SKARBOWY W GDYNI ",
    "2209 DRUGI URZĄD SKARBOWY W GDYNI ",
    "2210 URZĄD SKARBOWY W KARTUZACH ",
    "2211 URZĄD SKARBOWY W KOŚCIERZYNIE ",
    "2212 URZĄD SKARBOWY W KWIDZYNIE ",
    "2213 URZĄD SKARBOWY W LĘBORKU ",
    "2214 URZĄD SKARBOWY W MALBORKU ",
    "2215 URZĄD SKARBOWY W PUCKU ",
    "2216 URZĄD SKARBOWY W SŁUPSKU ",
    "2217 URZĄD SKARBOWY W SOPOCIE ",
    "2218 URZĄD SKARBOWY W STAROGARDZIE GDAŃSKIM ",
    "2219 URZĄD SKARBOWY W TCZEWIE ",
    "2220 URZĄD SKARBOWY W WEJHEROWIE ",
    "2221 URZĄD SKARBOWY W PRUSZCZU GDAŃSKIM ",
    "2271 POMORSKI URZĄD SKARBOWY W GDAŃSKU ",
    "2402 URZĄD SKARBOWY W BĘDZINIE ",
    "2403 PIERWSZY URZĄD SKARBOWY W BIELSKU-BIAŁEJ ",
    "2404 DRUGI URZĄD SKARBOWY W BIELSKU-BIAŁEJ ",
    "2405 URZĄD SKARBOWY W BYTOMIU ",
    "2406 URZĄD SKARBOWY W CHORZOWIE ",
    "2407 URZĄD SKARBOWY W CIESZYNIE ",
    "2408 URZĄD SKARBOWY W CZECHOWICACH-DZIEDZICACH ",
    "2409 PIERWSZY URZĄD SKARBOWY W CZĘSTOCHOWIE ",
    "2410 DRUGI URZĄD SKARBOWY W CZĘSTOCHOWIE ",
    "2411 URZĄD SKARBOWY W DĄBROWIE GÓRNICZEJ ",
    "2412 PIERWSZY URZĄD SKARBOWY W GLIWICACH ",
    "2413 DRUGI URZĄD SKARBOWY W GLIWICACH ",
    "2414 URZĄD SKARBOWY W JASTRZĘBIU-ZDROJU ",
    "2415 URZĄD SKARBOWY W JAWORZNIE ",
    "2416 PIERWSZY URZĄD SKARBOWY W KATOWICACH ",
    "2417 DRUGI URZĄD SKARBOWY W KATOWICACH ",
    "2418 URZĄD SKARBOWY W KŁOBUCKU ",
    "2419 URZĄD SKARBOWY W LUBLIŃCU ",
    "2420 URZĄD SKARBOWY W MIKOŁOWIE ",
    "2421 URZĄD SKARBOWY W MYSŁOWICACH ",
    "2422 URZĄD SKARBOWY W MYSZKOWIE ",
    "2423 URZĄD SKARBOWY W PIEKARACH ŚLĄSKICH ",
    "2424 URZĄD SKARBOWY W PSZCZYNIE ",
    "2425 URZĄD SKARBOWY W RACIBORZU ",
    "2426 URZĄD SKARBOWY W RUDZIE ŚLĄSKIEJ ",
    "2427 URZĄD SKARBOWY W RYBNIKU ",
    "2428 URZĄD SKARBOWY W SIEMIANOWICACH ŚLĄSKICH ",
    "2429 URZĄD SKARBOWY W SOSNOWCU ",
    "2430 URZĄD SKARBOWY W TARNOWSKICH GÓRACH ",
    "2431 URZĄD SKARBOWY W TYCHACH ",
    "2432 URZĄD SKARBOWY W WODZISŁAWIU ŚLĄSKIM ",
    "2433 URZĄD SKARBOWY W ZABRZU ",
    "2434 URZĄD SKARBOWY W ZAWIERCIU ",
    "2435 URZĄD SKARBOWY W ŻORACH ",
    "2436 URZĄD SKARBOWY W ŻYWCU ",
    "2471 PIERWSZY ŚLĄSKI URZĄD SKARBOWY W SOSNOWCU ",
    "2472 DRUGI ŚLĄSKI URZĄD SKARBOWY W BIELSKU-BIAŁEJ ",
    "2602 URZĄD SKARBOWY W BUSKU-ZDROJU ",
    "2603 URZĄD SKARBOWY W JĘDRZEJOWIE ",
    "2604 PIERWSZY URZĄD SKARBOWY W KIELCACH ",
    "2605 DRUGI URZĄD SKARBOWY W KIELCACH ",
    "2606 URZĄD SKARBOWY W KOŃSKICH ",
    "2607 URZĄD SKARBOWY W OPATOWIE ",
    "2608 URZĄD SKARBOWY W OSTROWCU ŚWIĘTOKRZYSKIM ",
    "2609 URZĄD SKARBOWY W PIŃCZOWIE ",
    "2610 URZĄD SKARBOWY W SANDOMIERZU ",
    "2611 URZĄD SKARBOWY W SKARŻYSKU-KAMIENNEJ ",
    "2612 URZĄD SKARBOWY W STARACHOWICACH ",
    "2613 URZĄD SKARBOWY W STASZOWIE ",
    "2614 URZĄD SKARBOWY W KAZIMIERZY WIELKIEJ ",
    "2615 URZĄD SKARBOWY WE WŁOSZCZOWIE ",
    "2671 ŚWIĘTOKRZYSKI URZĄD SKARBOWY W KIELCACH ",
    "2802 URZĄD SKARBOWY W BARTOSZYCACH ",
    "2803 URZĄD SKARBOWY W BRANIEWIE ",
    "2804 URZĄD SKARBOWY W DZIAŁDOWIE ",
    "2805 URZĄD SKARBOWY W ELBLĄGU ",
    "2806 URZĄD SKARBOWY W EŁKU ",
    "2807 URZĄD SKARBOWY W GIŻYCKU ",
    "2808 URZĄD SKARBOWY W IŁAWIE ",
    "2809 URZĄD SKARBOWY W KĘTRZYNIE ",
    "2810 URZĄD SKARBOWY W NIDZICY ",
    "2811 URZĄD SKARBOWY W NOWYM MIEŚCIE LUBAWSKIM ",
    "2812 URZĄD SKARBOWY W OLECKU ",
    "2813 URZĄD SKARBOWY W OLSZTYNIE ",
    "2814 URZĄD SKARBOWY W OSTRÓDZIE ",
    "2815 URZĄD SKARBOWY W PISZU ",
    "2816 URZĄD SKARBOWY W SZCZYTNIE ",
    "2871 WARMIŃSKO-MAZURSKI URZĄD SKARBOWY W OLSZTYNIE ",
    "3002 URZĄD SKARBOWY W CZARNKOWIE ",
    "3003 URZĄD SKARBOWY W GNIEŹNIE ",
    "3004 URZĄD SKARBOWY W GOSTYNIU ",
    "3005 URZĄD SKARBOWY W GRODZISKU WIELKOPOLSKIM ",
    "3006 URZĄD SKARBOWY W JAROCINIE ",
    "3007 PIERWSZY URZĄD SKARBOWY W KALISZU ",
    "3008 DRUGI URZĄD SKARBOWY W KALISZU ",
    "3009 URZĄD SKARBOWY W KĘPNIE ",
    "3010 URZĄD SKARBOWY W KOLE ",
    "3011 URZĄD SKARBOWY W KONINIE ",
    "3012 URZĄD SKARBOWY W KOŚCIANIE ",
    "3013 URZĄD SKARBOWY W KROTOSZYNIE ",
    "3014 URZĄD SKARBOWY W LESZNIE ",
    "3015 URZĄD SKARBOWY W MIĘDZYCHODZIE ",
    "3016 URZĄD SKARBOWY W NOWYM TOMYŚLU ",
    "3017 URZĄD SKARBOWY W OSTROWIE WIELKOPOLSKIM ",
    "3018 URZĄD SKARBOWY W OSTRZESZOWIE ",
    "3019 URZĄD SKARBOWY W PILE ",
    "3020 URZĄD SKARBOWY POZNAŃ-GRUNWALD ",
    "3021 URZĄD SKARBOWY POZNAŃ-JEŻYCE ",
    "3022 URZĄD SKARBOWY POZNAŃ-NOWE MIASTO ",
    "3023 PIERWSZY URZĄD SKARBOWY W POZNANIU ",
    "3025 URZĄD SKARBOWY POZNAŃ-WINOGRADY ",
    "3026 URZĄD SKARBOWY POZNAŃ-WILDA ",
    "3027 URZĄD SKARBOWY W RAWICZU ",
    "3028 URZĄD SKARBOWY W SŁUPCY ",
    "3029 URZĄD SKARBOWY W SZAMOTUŁACH ",
    "3030 URZĄD SKARBOWY W ŚREMIE ",
    "3031 URZĄD SKARBOWY W ŚRODZIE WIELKOPOLSKIEJ ",
    "3032 URZĄD SKARBOWY W TURKU ",
    "3033 URZĄD SKARBOWY W WĄGROWCU ",
    "3034 URZĄD SKARBOWY W WOLSZTYNIE ",
    "3035 URZĄD SKARBOWY WE WRZEŚNI ",
    "3036 URZĄD SKARBOWY W ZŁOTOWIE ",
    "3037 URZĄD SKARBOWY W CHODZIEŻY ",
    "3038 URZĄD SKARBOWY W OBORNIKACH ",
    "3039 URZĄD SKARBOWY W PLESZEWIE ",
    "3071 PIERWSZY WIELKOPOLSKI URZĄD SKARBOWY W POZNANIU ",
    "3072 DRUGI WIELKOPOLSKI URZĄD SKARBOWY W KALISZU ",
    "3202 URZĄD SKARBOWY W BIAŁOGARDZIE ",
    "3203 URZĄD SKARBOWY W CHOSZCZNIE ",
    "3204 URZĄD SKARBOWY W DRAWSKU POMORSKIM ",
    "3205 URZĄD SKARBOWY W GOLENIOWIE ",
    "3206 URZĄD SKARBOWY W GRYFICACH ",
    "3207 URZĄD SKARBOWY W GRYFINIE ",
    "3208 URZĄD SKARBOWY W KAMIENIU POMORSKIM ",
    "3209 URZĄD SKARBOWY W KOŁOBRZEGU ",
    "3210 PIERWSZY URZĄD SKARBOWY W KOSZALINIE ",
    "3211 DRUGI URZĄD SKARBOWY W KOSZALINIE ",
    "3212 URZĄD SKARBOWY W MYŚLIBORZU ",
    "3213 URZĄD SKARBOWY W PYRZYCACH ",
    "3214 URZĄD SKARBOWY W STARGARDZIE SZCZECIŃSKIM ",
    "3215 PIERWSZY URZĄD SKARBOWY W SZCZECINIE ",
    "3216 DRUGI URZĄD SKARBOWY W SZCZECINIE ",
    "3217 TRZECI URZĄD SKARBOWY W SZCZECINIE ",
    "3218 URZĄD SKARBOWY W SZCZECINKU ",
    "3219 URZĄD SKARBOWY W ŚWINOUJŚCIU ",
    "3220 URZĄD SKARBOWY W WAŁCZU ",
    "3271 ZACHODNIOPOMORSKI URZĄD SKARBOWY W SZCZECINIE"
  )

  val listOfTitles = listOf(
    "tytuł wykonawczy",
    "zmieniony tytuł wykonawczy",
    "dalszy tytuł wykonawczy",
    "ponowny tytuł wykonawczy"
  )

  val listOfAims = listOf(
    "prowadzenie egzekucji przez inny organ egzekucyjny",
    "zabezpieczenie hipoteką przymusową, w tym hipoteką przymusową morską",
    "ponowne wszczęcie egzekucji administracyjnej"
  )

  val listOfRelates = listOf(
    "tytułu wykonawczego",
    "zmienionego tytułu wykonawczego"
  )

  val listOfRelatesPierwszyDokument = listOf(
    "tytuł wykonawczy",
    "dalszy tytuł wykonawczy"
  )

  val listOfCountryCodes = listOf(
    "AF",
    "AX",
    "AL",
    "DZ",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AG",
    "AN",
    "SA",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BY",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BR",
    "BN",
    "IO",
    "BG",
    "BF",
    "BI",
    "XC",
    "CL",
    "CN",
    "HR",
    "CW",
    "CY",
    "TD",
    "ME",
    "DK",
    "DM",
    "DO",
    "DJ",
    "EG",
    "EC",
    "ER",
    "EE",
    "ET",
    "FK",
    "FJ",
    "PH",
    "FI",
    "FR",
    "TF",
    "GA",
    "GM",
    "GH",
    "GI",
    "GR",
    "GD",
    "GL",
    "GE",
    "GU",
    "GG",
    "GY",
    "GF",
    "GP",
    "GT",
    "GN",
    "GQ",
    "GW",
    "HT",
    "ES",
    "HN",
    "HK",
    "IN",
    "ID",
    "IQ",
    "IR",
    "IE",
    "IS",
    "IL",
    "JM",
    "JP",
    "YE",
    "JE",
    "JO",
    "KY",
    "KH",
    "CM",
    "CA",
    "QA",
    "KZ",
    "KE",
    "KG",
    "KI",
    "CO",
    "KM",
    "CG",
    "CD",
    "KP",
    "XK",
    "CR",
    "CU",
    "KW",
    "LA",
    "LS",
    "LB",
    "LR",
    "LY",
    "LI",
    "LT",
    "LV",
    "LU",
    "MK",
    "MG",
    "YT",
    "MO",
    "MW",
    "MV",
    "MY",
    "ML",
    "MT",
    "MP",
    "MA",
    "MQ",
    "MR",
    "MU",
    "MX",
    "XL",
    "FM",
    "UM",
    "MD",
    "MC",
    "MN",
    "MS",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "DE",
    "NE",
    "NG",
    "NI",
    "NU",
    "NF",
    "NO",
    "NC",
    "NZ",
    "PS",
    "OM",
    "PK",
    "PW",
    "PA",
    "PG",
    "PY",
    "PE",
    "PN",
    "PF",
    "PL",
    "GS",
    "PT",
    "PR",
    "CF",
    "CZ",
    "KR",
    "ZA",
    "RE",
    "RU",
    "RO",
    "RW",
    "EH",
    "BL",
    "KN",
    "LC",
    "MF",
    "VC",
    "SV",
    "WS",
    "AS",
    "SM",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SK",
    "SI",
    "SO",
    "LK",
    "PM",
    "US",
    "SZ",
    "SD",
    "SS",
    "SR",
    "SJ",
    "SH",
    "SY",
    "CH",
    "SE",
    "TJ",
    "TH",
    "TW",
    "TZ",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TV",
    "UG",
    "UA",
    "UY",
    "UZ",
    "VU",
    "WF",
    "VA",
    "HU",
    "VE",
    "GB",
    "VN",
    "IT",
    "TL",
    "CI",
    "BV",
    "CX",
    "IM",
    "SX",
    "CK",
    "VI",
    "VG",
    "HM",
    "CC",
    "MH",
    "FO",
    "SB",
    "ST",
    "TC",
    "ZM",
    "CV",
    "ZW",
    "AE"
  )

  val listOfResponsibilityTypes = listOf(
    "podmiot, u którego powstał obowiązek",
    "następca prawny",
    "osoba trzecia"
  )

  val listOfReceivable = listOf(
    "Podatkowa",
    "Inna"
  )

  val listOfInterest = listOf(
    "Za zwłokę",
    "Za zwłokę od należności celnych",
    "Ustawowe",
    "Ustawowe za opóźnienie",
    "Ustawowe za opóźnienie w transakcjach handlowych",
    "Naliczane wg stawek stosowanych przez EBC"
  )

  val optionsOfObligated = listOf(
    "0" to "Osoba fizyczna",
    "1" to "Małżonkowie odpowiedzialni solidarnie",
    "2" to "Osoba prawna",
    "3" to "Jednostka organizacyjna niebędąca osobą prawną",
    "4" to "Podmiot w organizacji",
    "5" to "Przedsiębiorstwo w spadku"
  )

  val optionsOfTakNie = listOf(
    "0" to "Nie dotyczy",
    "1" to "Nie",
    "2" to "Tak"
  )

  val optionsOfPrimalObligated = listOf(
    "0" to "Osoba fizyczna",
    "1" to "Podmiot niebędący osobą fizyczną",
  )

  val optionsOfPierwotnyObligated = listOf(
    "0" to "Osoba fizyczna",
    "1" to "Małżonkowie odpowiedzialni solidarnie",
    "2" to "Osoba prawna",
    "3" to "Jednostka organizacyjna niebędąca osobą prawną",
    "4" to "Podmiot w organizacji"
  )

  val optionsOfOIdentity = listOf(
    "0" to "NIP",
    "1" to "PESEL",
    "2" to "REGON",
    "3" to "Oświadczenie Wierzyciela"
  )

  val optionsOfOIdentityZalacznik = listOf(
    "0" to "NIP",
    "1" to "PESEL",
    "2" to "Oświadczenie Wierzyciela"
  )

  val optionsOfOIdentityNonPhysicalWithoutOswiadczenie = listOf(
    "0" to "REGON",
    "1" to "NIP"
  )

  val optionsOfOIdentityNonPhysical = listOf(
    "0" to "REGON",
    "1" to "NIP",
    "2" to "Oświadczenie Wierzyciela"
  )

  val optionsOfAdress = listOf(
    "0" to "Adres polski",
    "1" to "Adres zagraniczny"
  )

  val optionsOfLegalBasis = listOf(
    "0" to "Z mocy prawa",
    "1" to "Dokument, o którym mowa w art. 3a § 1 ustawy",
    "2" to "Orzeczenie"
  )

  val optionsOfDelivered = listOf(
    "0" to "Podstawa prawna braku obowiązku doręczenia upomnienia",
    "1" to "Upomnienie",
    "2" to "Powiadomienie"
  )

  val optionsOfObligation = listOf(
    "0" to "Nie pobiera się odsetek",
    "1" to "Pobiera się odsetki we wskazanej stawce"
  )

  val optionsOfRates = listOf(
    "0" to "Stawka odsetek",
    "1" to "Podwyższona stawka odsetek"
  )

  val optionsOfWierzyciel = listOf(
    "0" to "Wierzyciel",
    "1" to "Organ upoważniony do wykonywania praw i obowiązków w imieniu wierzyciela"
  )

  val optionsOfWierzycielNaleznosc = listOf(
    "0" to "Wierzyciela",
    "1" to "Innego podmiotu"
  )

  val optionsOfConcers = listOf(
    "0" to "posiadanego przez zobowiązanego składnika majątkowego lub źródła jego dochodu",
    "1" to "majątek zobowiązanego lub większa jego część znajdująca się na terenie działania organu egzekucyjnego",
    "2" to "siedziby lub miejsca zamieszkania dłużnika zobowiązanego, który jest obciążony prawem majątkowym względem zobowiązanego",
    "3" to "daty wysłania przez centralne biuro łącznikowe wniosku o udzielenie informacji lub powiadomienie do państwa członkowskiego lub państwa trzeciego oraz numeru referencyjnego tego wniosku",
    "4" to "ujawnionego po umorzeniu postępowania egzekucyjnego na podstawie art. 59 § 2 składnika majątkowego lub źródła dochodu zobowiązanego oraz numeru i daty wydania postanowienia o umorzeniu postępowania egzekucyjnego",
    "5" to "małżonek odpowiedzialny majątkiem wspólnym",
    "6" to "podmiot niebędący zobowiązanym, na który zostało przeniesione prawo własności rzeczy lub inne prawo majątkowe obciążone zastawem skarbowym lub hipoteką przymusową",
    "7" to "podmiot, który uzyskał korzyść majątkową",
    "8" to "imienia i nazwiska oraz adresu do korespondencji przedstawiciela ustawowego/opiekuna/kuratora zobowiązanego",
    "9" to "imienia i nazwiska oraz adresu do korespondencji zarządcy przedsiębiorstwa w spadku",
    //"6" to "majątku zobowiązanego lub większej jego części znajdującego się na terenie działania organu egzekucyjnego",
    "10" to "innych okoliczności niewskazanych w ustawie"
  )

  val statement =
    "Wierzyciel oświadcza, że dokonał sprawdzenia na obecność posiadania przez podmiot identyfikatorów NIP i PESEL. Podmiot nie posiada wskazanych identyfikatorów lub nie było możliwości ich ustalenia."

  val inDecline = "w spadku, zaznacza się w przypadku przedsiębiorcy w spadku"

  val listOfCashReceivableCollateral = listOf(
    "zabezpieczenie należności pieniężnej hipoteką przymusową",
    "zabezpieczenie należności pieniężnej zastawem skarbowym",
    "zabezpieczenie należności pieniężnej zastawem rejestrowym",
    "zabezpieczenie należności pieniężnej zastawem nieujawnionym w żadnym rejestrze"
  )
  val listOfRepresentativeTypes = listOf(
    "Przedstawiciel ustawowy zobowiązanego",
    "Opiekun zobowiązanego",
    "Kurator zobowiązanego"
  )
}
